"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcClippedResult = exports.downloadImage = void 0;
function downloadImage(imageUrl, fileName, clipStyle) {
    if (!imageUrl) {
        return;
    }
    var _a = imageUrl.split('?'), url = _a[0], params = _a[1];
    var timestamp = "timestamp=" + Date.now();
    var appendedParams = params ? params + "&" + timestamp : timestamp;
    var downloadImageUrl = url + "?" + appendedParams;
    if (clipStyle) {
        downloadClippedImage(downloadImageUrl, fileName, clipStyle);
    }
    else {
        downloadOriginalImage(downloadImageUrl, fileName);
    }
}
exports.downloadImage = downloadImage;
function downloadClippedImage(url, fileName, clipStyle) {
    var image = new Image();
    image.setAttribute('crossOrigin', 'anonymous');
    var canvas = document.createElement('canvas');
    image.onload = function () {
        var _a = calcClippedResult(image, clipStyle), width = _a.clippedWidth, height = _a.clippedHeight, marginLeft = _a.clippedLeft, marginTop = _a.clippedTop;
        canvas.width = width;
        canvas.height = height;
        var context = canvas.getContext('2d');
        if (context) {
            context.drawImage(image, marginLeft, marginTop, width, height, 0, 0, width, height);
            var url_1 = canvas.toDataURL('image/png');
            triggerDownload(url_1, fileName);
        }
    };
    image.src = url;
}
function downloadOriginalImage(url, fileName) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function () {
        if (xhr.status === 200 && xhr.response) {
            if (xhr.response.type && xhr.response.type.indexOf('image/') >= 0) {
                var blobUrl_1 = URL.createObjectURL(xhr.response);
                triggerDownload(blobUrl_1, fileName);
                setTimeout(function () {
                    URL.revokeObjectURL(blobUrl_1);
                }, 5000);
            }
        }
    };
    xhr.send();
}
function triggerDownload(url, fileName) {
    var aElement = document.createElement('a');
    aElement.download = fileName;
    aElement.href = url;
    aElement.click();
}
function calcClippedResult(image, clipStyle) {
    var clippedWidth = 0;
    var clippedHeight = 0;
    var clippedLeft = 0;
    var clippedTop = 0;
    if (!image) {
        return { clippedLeft: clippedLeft, clippedTop: clippedTop, clippedWidth: clippedWidth, clippedHeight: clippedHeight };
    }
    var initialWidth = image.width, initialHeight = image.height;
    clippedWidth = initialWidth;
    clippedHeight = initialHeight;
    if (clipStyle) {
        var width = clipStyle.width, height = clipStyle.height, marginLeft = clipStyle.marginLeft, marginTop = clipStyle.marginTop;
        clippedWidth = width <= 1 ? width * initialWidth : width;
        clippedHeight = height <= 1 ? height * initialHeight : height;
        clippedLeft = Math.abs(marginLeft) < 1 ? marginLeft * initialWidth : marginLeft;
        clippedTop = Math.abs(marginTop) < 1 ? marginTop * initialHeight : marginTop;
    }
    return { clippedLeft: clippedLeft, clippedTop: clippedTop, clippedWidth: clippedWidth, clippedHeight: clippedHeight };
}
exports.calcClippedResult = calcClippedResult;
